import React from 'react';
import { Grid, Row, Col, Panel } from 'react-bootstrap';
import { Field, reduxForm } from "redux-form";
import { MultiSelectField } from '../../common/Inputs';

let Filter = class extends React.Component {
    constructor(props) {
        super(props);
        this.state = { states:[] };
    }
    
    componentDidMount() {
        this.setState({ states: this.props.statesSelector ? this.props.statesSelector() : this.props.states });
    }
    render() {
    return (
        <Grid fluid={true} >
            <Row>
                <Col lg={12}>
                    <Panel>
                        <Panel.Heading>Фильтр</Panel.Heading>
                        <Panel.Body>
                            <form className='form-horizontal' style={{ display: 'flex' }} >
                                <Field name='states' component={MultiSelectField} data={this.state.states}
                                    valueField='Id'
                                    textField='Name'
                                    label='Статус' />
                            </form>
                        </Panel.Body>

                    </Panel>
                </Col>
            </Row>
        </Grid>);
    }
}

Filter = reduxForm({
    form: 'ordersFilter',
})(Filter);

export default Filter;


// WEBPACK FOOTER //
// ./src/components/orders/filters/OrderStateFilter.jsx